import { Component } from '@theme/component';
import { StandardEvents } from '@shopify/events';

class BrovaleBasket extends Component {
  requiredRefs = ['count', 'link'];
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(StandardEvents.cartLinesUpdate, this.onCartUpdate);
    window.addEventListener('pageshow', this.onPageShow);
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(StandardEvents.cartLinesUpdate, this.onCartUpdate);
    window.removeEventListener('pageshow', this.onPageShow);
    this.request?.abort();
  }
  setCount(count) {
    if (!Number.isInteger(count) || count < 0) return;
    this.refs.count.textContent = String(count);
    this.refs.link.setAttribute('aria-label', `${this.dataset.label} (${count})`);
  }
  onCartUpdate = (event) => {
    event.promise?.then(({ cart, detail }) => {
      const count = cart?.totalQuantity ?? detail?.itemCount;
      if (Number.isInteger(count)) this.setCount(count);
      else this.refresh();
    }).catch(() => {});
  };
  onPageShow = (event) => { if (event.persisted) this.refresh(); };
  async refresh() {
    this.request?.abort();
    this.request = new AbortController();
    try {
      const response = await fetch(`${window.Shopify?.routes?.root ?? '/'}cart.js`, { signal: this.request.signal, headers: { Accept: 'application/json' } });
      if (response.ok) this.setCount((await response.json()).item_count);
    } catch (_) {}
  }
}
if (!customElements.get('brovale-basket')) customElements.define('brovale-basket', BrovaleBasket);
